import React from "react";
import { Link } from "react-router-dom";
import Services from "../../api/service";

const Service6 = (props) => {
	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className="wpo-features-section-s6 section-padding">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-lg-6">
						<div className="wpo-section-title">
							<span>Mentorship Programs</span>
							<h2>Empowering Growth through Mentorship</h2>{" "}
							<p>
								Our Mentorship programs support students' academic, personal,
								and spiritual growth through dedicated weekly sessions, role
								model development, and immersive youth camps. From one-on-one
								mentorship to hands-on camps, each program fosters a nurturing
								environment where students gain valuable skills, build
								meaningful connections, and grow into compassionate, capable
								leaders for the future.
							</p>
						</div>
					</div>
				</div>
				<div className="row justify-content-center">
					{Services.slice(4, 7).map((service, sitem) => (
						<div className="col col-xl-4 col-lg-4 col-sm-6 col-12" key={sitem}>
							<div className="wpo-features-item">
								<div className="wpo-features-icon">
									<div className="icon">
										<i className="fi">{service.icon}</i>
									</div>
								</div>
								<div className="wpo-features-text">
									<h2>
										<Link
											onClick={ClickHandler}
											to={`/${service.id}`}
										>
											{service.title}
										</Link>
									</h2>
									<p>{service.description}</p>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default Service6;
